"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyPageRequest = void 0;
var MyPageRequest = /** @class */ (function () {
    function MyPageRequest() {
    }
    return MyPageRequest;
}());
exports.MyPageRequest = MyPageRequest;
//# sourceMappingURL=myPage.request.js.map